import React from 'react';
import { Box, Typography } from '@mui/material';
import ProxySettingsContent from '../components/ProxySettingsContent';
import ProxySettingsTools from '../components/ProxySettingsTools';
import { DFT_BRAND, zoomedMainMinHeight } from '../styles/brandPalette';

const PROXY_CARD_RADIUS = '14px';
const proxyPageSx = {
  width: '100%',
  maxWidth: 'none',
  minWidth: 0,
  alignSelf: 'stretch',
  flex: 1,
  px: 0,
  py: 0,
  bgcolor: 'transparent',
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  boxSizing: 'border-box' as const,
  minHeight: {
    xs: 'calc(100dvh - 64px)',
    ...zoomedMainMinHeight(),
  },
  '& .MuiCard-root': {
    borderRadius: `${PROXY_CARD_RADIUS} !important`,
    overflow: 'hidden',
  },
  '& .MuiAlert-root': {
    borderRadius: '12px',
  },
  '& .MuiTypography-body2': {
    fontSize: '0.875rem',
    lineHeight: 1.45,
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
  },
} as const;
const PROXY_WORKSPACE_SX = {
  flex: '1 1 auto',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '0 12px 12px 12px',
  border: `1px solid ${DFT_BRAND.line}`,
  borderTop: `1px solid ${DFT_BRAND.line}`,
  bgcolor: DFT_BRAND.bg,
  boxShadow: 'none',
  overflow: 'visible',
  p: { xs: 1.25, sm: 1.5 },
  gap: 1.5,
} as const;

const ProxySettings: React.FC = () => {
  return (
    <Box sx={proxyPageSx}>
      <Box sx={{ width: '100%', flexShrink: 0, overflow: 'visible' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            gap: 1,
            minWidth: 0,
            px: { xs: 1.25, sm: 1.5 },
            pt: 1.25,
            pb: 1.25,
            minHeight: 36,
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{
              m: 0,
              fontWeight: 700,
              height: 36,
              lineHeight: '36px',
              letterSpacing: '-0.02em',
              color: DFT_BRAND.text,
              whiteSpace: 'nowrap',
            }}
          >
            Proxy Settings
          </Typography>
        </Box>
      </Box>

      <Box sx={PROXY_WORKSPACE_SX}>
        <ProxySettingsContent active footer="page" showHeader={false} />
        <ProxySettingsTools />
      </Box>
    </Box>
  );
};

export default ProxySettings;
